// ── BoxRunner.Web/src/hooks/useNotifications.ts ───────────────────────────────
// Call this hook on login to register FCM token and request permission

import { useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyC6AkOOWzgAgiR5VMWL90t4dEAneoqsV8s",
    authDomain: "boxrunner-e3f3a.firebaseapp.com",
    projectId: "boxrunner-e3f3a",
    storageBucket: "boxrunner-e3f3a.firebasestorage.app",
    messagingSenderId: "321745765022",
    appId: "1:321745765022:web:3b800c2892e1be8a82f18f"
};

const VAPID_KEY = "BAG2Q0PW7no7KsBGWwaY4cUGeONc1jw6UbepcHZYBh3lNaddSqEPMFx3IqQJVSy1e26u7MuKl0nhN8-g6MFEAaI";
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

let app: any = null;
let messaging: any = null;

function getFirebaseApp() {
    if (!app) app = initializeApp(firebaseConfig);
    return app;
}

function getFirebaseMessaging() {
    if (!messaging) messaging = getMessaging(getFirebaseApp());
    return messaging;
}

export function useNotifications(userId: string | null, role: string | null) {
    useEffect(() => {
        if (!userId || !role) return;
        if (!('Notification' in window)) return;
        if (!('serviceWorker' in navigator)) return;

        const registerToken = async () => {
            try {
                // Register service worker
                const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

                // Request permission
                const permission = await Notification.requestPermission();
                if (permission !== 'granted') {
                    console.log('Notification permission denied');
                    return;
                }

                // Get FCM token
                const msg = getFirebaseMessaging();
                const token = await getToken(msg, {
                    vapidKey: VAPID_KEY,
                    serviceWorkerRegistration: registration
                });

                if (!token) return;

                // Save token to backend
                const authToken = localStorage.getItem('br_token');
                await fetch(`${API_BASE}/api/notifications/register`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify({ fcmToken: token, role })
                });

                console.log('FCM token registered');

                // Handle foreground messages — route through service worker so the
                // OS shows a proper system notification (new Notification() from the
                // page context is blocked in Chrome when the tab is active).
                onMessage(msg, payload => {
                    const { title, body } = payload.notification || {};
                    if (title && body && Notification.permission === 'granted') {
                        registration.showNotification(title, {
                            body,
                            icon: '/logo192.png',
                            badge: '/logo192.png',
                        } as NotificationOptions);
                    }
                });

            } catch (err) {
                console.error('FCM registration failed:', err);
            }
        };

        registerToken();
    }, [userId, role]);
}
